import { noNetwork } from 'src/app/models/placeholder';
import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'no-network',
  templateUrl: './no-network.component.html',
  styleUrls: ['./no-network.component.scss'],
})
export class NoNetworkComponent implements OnInit {
  image: string;
  constructor(private navControl: NavController) {
    this.image = noNetwork;
  }
  ngOnInit() {}

  reloadPage() {
    this.navControl.navigateForward('/shopping');
  }
}
